import React, { useEffect, useRef, useState } from "react";
import { getKoreaNowDate } from "../../../../../utils/serverTime";

// 오늘(KST) 마감시간까지 남은 시간을 1초마다 갱신해서 보여주는 타이머.
// 마감 전에 폼을 작성해두고 한참 뒤에 제출해 마감을 놓치는 걸 막기 위한 시각적 안내용.
// onExpire: 마감 순간(0을 지나는 시점)에 정확히 한 번 호출됨. 부모가 이걸로
// getMinStartDate() 등 마감시간에 의존하는 값을 그 순간 다시 계산하도록 리렌더를 트리거할 수 있음
// (타이머는 이 컴포넌트 내부에서만 똑딱이므로, 그 신호가 없으면 부모의 값은 저절로 안 바뀜)
const DeadlineCountdown = ({ endSubmitTime, isOff, onExpire }) => {
  const [remainingMs, setRemainingMs] = useState(null);
  const hasFiredExpireRef = useRef(false);

  useEffect(() => {
    if (isOff || !endSubmitTime) {
      setRemainingMs(null);
      return undefined;
    }

    const [endHour, endMinute] = endSubmitTime.split(":").map(Number);

    // koreaNow는 서버 시간으로 보정된 UTC+9 "가짜 UTC" 표현 (다른 KST 계산과 동일한 방식)
    const computeRemainingMs = () => {
      const koreaNow = getKoreaNowDate();
      const deadline = new Date(koreaNow.getTime());
      deadline.setUTCHours(endHour, endMinute, 0, 0);
      return deadline.getTime() - koreaNow.getTime();
    };

    const tick = () => {
      const ms = computeRemainingMs();
      setRemainingMs(ms);
      if (ms <= 0 && !hasFiredExpireRef.current) {
        hasFiredExpireRef.current = true;
        onExpire?.();
      }
    };

    hasFiredExpireRef.current = false;
    tick();
    const timer = setInterval(tick, 1000);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endSubmitTime, isOff]);

  if (isOff) return null;

  if (remainingMs === null) return null;

  if (remainingMs <= 0) {
    return (
      <span className="add-deadline-countdown is-expired">
        오늘 주문이 마감되었습니다
      </span>
    );
  }

  const totalSeconds = Math.floor(remainingMs / 1000);
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
    2,
    "0",
  );
  const seconds = String(totalSeconds % 60).padStart(2, "0");

  return (
    <span className="add-deadline-countdown">
      주문 마감까지{" "}
      <strong>
        {hours}:{minutes}:{seconds}
      </strong>
    </span>
  );
};

export default DeadlineCountdown;
